import React from "react";

function CopyLink() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
    >
      <g
        id="Group_26074"
        data-name="Group 26074"
        transform="translate(-14352 9458)"
      >
        <circle
          id="Ellipse_2347"
          data-name="Ellipse 2347"
          cx="28"
          cy="28"
          r="28"
          transform="translate(14352 -9458)"
          fill="#d4e3ed"
        />
        <path
          id="Path_18491"
          data-name="Path 18491"
          d="M7.8,6.8V3.2A1.2,1.2,0,0,1,9,2H23.4a1.2,1.2,0,0,1,1.2,1.2V20a1.2,1.2,0,0,1-1.2,1.2H19.8v3.6A1.2,1.2,0,0,1,18.592,26H4.208A1.2,1.2,0,0,1,3,24.8L3,8A1.2,1.2,0,0,1,4.211,6.8ZM5.4,9.2l0,14.4h12V9.2Zm4.8-2.4h9.6v12h2.4V4.4h-12Z"
          transform="translate(14366 -9444)"
          fill="#242424"
        />
      </g>
    </svg>
  );
}

export default CopyLink;
